import { gql } from '@apollo/client';

export const AgentEmailMatches = gql`
    query AgentEmailMatches($where: agent_email_matches_bool_exp!, $limit: Int!, $offset: Int!) {
        messages: agent_email_matches(
            where: $where
            limit: $limit
            offset: $offset
            order_by: [{ internalDate: desc }, { account: asc }, { messageId: asc }]
        ) {
            account
            messageId
            internalDate
            sender
            subject
            personIds
            jobIds
            matchData
        }
        total: agent_email_matches_aggregate(where: $where) {
            aggregate {
                count
            }
        }
    }
`;

export const MarkAgentEmailMatchReviewed = gql`
    mutation MarkAgentEmailMatchReviewed($account: String!, $messageId: String!) {
        messages: mark_agent_email_match_reviewed(args: { account_email: $account, message_id: $messageId }) {
            account
            messageId
        }
    }
`;
